import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center pt-16">
      <div className="text-center px-4">
        <div className="w-24 h-24 mx-auto mb-6 bg-background-100 rounded-full flex items-center justify-center">
          <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
        </div>
        <h1 className="text-3xl font-bold text-foreground-950 mb-2 font-heading">
          404
        </h1>
        <p className="text-foreground-500 mb-8">
          抱歉，您访问的页面不存在
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
          返回首页
        </Link>
      </div>
    </main>
  );
}